import { type ComponentPropsWithRef } from "react";
import { Input } from "@design-system/Input/Input";

export const ScheduleNumericInput = (
    props: Omit<ComponentPropsWithRef<"input">, "size">,
) => <Input {...props} size="md" />;
